import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class SubMenuItem extends withBreakpointObserver(Base) {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Sub$SubMenuItem',
    refs: ['childPanel', 'link'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s m',
      },
    },
  };

  /**
   * Open child panel
   * @param  {object} e
   * @returns {void}
   */
  onLinkClick(e) {
    e.preventDefault();
    this.$refs.childPanel.classList.toggle('hidden');
  }
}
